import { render } from "./ActionEdit.vue?vue&type=template&id=601c23bc&scoped=true"
import script from "./ActionEdit.vue?vue&type=script&lang=js"
export * from "./ActionEdit.vue?vue&type=script&lang=js"

import "./ActionEdit.vue?vue&type=style&index=0&id=601c23bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601c23bc"]])

export default __exports__